var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardSamsungPay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ec65834e-0e62-434d-a364-86f052dec34c",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 80",
    width: 120,
    height: 80,
    style: {
      enableBackground: "new 0 0 120 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4,0h112c2.2,0,4,1.8,4,4v72c0,2.2-1.8,4-4,4H4c-2.2,0-4-1.8-4-4V4C0,1.8,1.8,0,4,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.3,44.6H10v15.3h2.8v-4.4h2.4c3,0,5.4-2.4,5.4-5.5S18.2,44.6,15.3,44.6L15.3,44.6z M15.1,52.8h-2.2v-5.6 h2.2c1.6-0.1,2.9,1.1,3,2.6c0.1,1.6-1.1,2.9-2.6,3C15.3,52.8,15.2,52.8,15.1,52.8z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5,49.1c-1-1.1-2.4-1.7-3.9-1.7c-3.3,0-6.1,2.7-6.1,6c0,0.1,0,0.2,0,0.3c-0.1,3.4,2.5,6.2,5.9,6.4 c0,0,0.1,0,0.1,0c1.5,0,3-0.6,4-1.8v1.6h2.8V47.6h-2.8V49.1z M28,57.5c-2.1,0.1-3.8-1.6-3.9-3.7c-0.1-2.1,1.6-3.8,3.7-3.9 c2.1-0.1,3.8,1.6,3.9,3.7c0,0,0,0.1,0,0.1C31.7,55.7,30.1,57.4,28,57.5C28,57.5,28,57.5,28,57.5z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.9,55.8 38.5,47.6 35.5,47.6 40.5,59.2 37.9,65.5 40.8,65.5 48.1,47.6 45.1,47.6",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.8,32.3 92.7,32.3 89.4,21 84.1,21 84.1,35.2 87.6,35.2 87.4,23.6 87.5,23.6 91,35.2 96.1,35.2 96.1,21 92.6,21",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.5,22.4 28.5,22.4 30.5,35.3 34.3,35.3 31.7,21 25.3,21 22.6,35.3 26.5,35.3",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.9,21 45.1,32 45,32 43.3,21 37.5,21 37.2,35.3 40.7,35.3 40.8,22.5 40.9,22.5 43.3,35.3 46.9,35.3 49.3,22.5 49.4,22.5 49.5,35.3 53,35.3 52.7,21",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2,35.9c2.6,0,4.7-0.9,5.1-3.3c0.1-0.8,0.1-1.6,0-2.4c-0.6-3-6-3.9-6.4-5.6c-0.1-0.3-0.1-0.5,0-0.8 c0.1-0.6,0.7-1.1,1.3-1c0.7-0.1,1.3,0.4,1.3,1.1c0,0.1,0,0.1,0,0.2v0.9H20v-1c0-3.1-2.8-3.6-4.8-3.6c-2.5,0-4.6,0.8-5,3.2 c-0.1,0.6-0.1,1.3,0,1.9c0.6,2.9,5.7,3.8,6.4,5.6l0,0c0.1,0.3,0.1,0.7,0,1.1c-0.1,0.7-0.7,1.1-1.4,1c-0.7,0.1-1.3-0.4-1.4-1.1 c0-0.1,0-0.1,0-0.2v-1.4H10v1.1C10,34.9,12.5,35.9,15.2,35.9z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3,24.8c-0.1-0.2-0.1-0.5,0-0.7c0.1-0.6,0.7-1,1.3-1c0.7-0.1,1.2,0.4,1.3,1.1c0,0.1,0,0.1,0,0.2v0.9h3.5v-1 c0-3.1-2.8-3.6-4.8-3.6c-2.5,0-4.6,0.8-4.9,3.1c-0.1,0.6-0.1,1.3,0,1.9c0.6,2.9,5.6,3.7,6.4,5.6l0,0c0.1,0.3,0.1,0.7,0,1 c-0.1,0.6-0.7,1.1-1.4,1c-0.7,0.1-1.3-0.5-1.4-1.1c0,0,0-0.1,0-0.1v-1.4h-3.8v1.1c0,3.2,2.5,4.1,5.1,4.1s4.7-0.9,5-3.2 c0.1-0.8,0.1-1.6,0-2.3C66.1,27.3,60.7,26.4,60.3,24.8z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1,21h-3.6v10.6c0,0.2,0,0.4,0,0.5c-0.1,0.6-0.7,1.1-1.4,1l0,0c-0.6,0.1-1.2-0.4-1.4-1c0-0.2,0-0.4,0-0.5 V21h-3.7v10.3c0,0.3,0,0.8,0,0.9c0.2,2.7,2.4,3.5,5,3.5s4.7-0.9,5-3.5c0-0.3,0-0.6,0-0.9L80.1,21z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.9,27.3v2.1h1.5v2.1c0,0.2,0,0.4,0,0.5c-0.2,0.7-0.8,1.1-1.5,1l0,0c-0.7,0.1-1.3-0.3-1.5-1 c0-0.2,0-0.4,0-0.5v-6.5c0-0.2,0-0.4,0.1-0.7c0.2-0.6,0.8-1.1,1.4-1c0.7-0.1,1.3,0.4,1.4,1c0,0.2,0.1,0.4,0.1,0.5v0.8h3.6v-0.5 c0-0.3,0-0.6,0-0.9c-0.3-2.7-2.5-3.5-5-3.5s-4.7,0.9-5,3.5c0,0.2-0.1,0.7-0.1,0.9v6c0,0.3,0,0.6,0.1,0.9c0.2,2.6,2.5,3.5,5,3.5 s4.8-0.9,5-3.5c0-0.5,0-0.7,0-0.9v-3.8H104.9z",
    style: {
      fill: "#FFFFFF"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSamsungPay);
export default __webpack_public_path__ + "static/media/card_samsung-pay.41e37912c45df254cb731a396a213a99.svg";
export { ForwardRef as ReactComponent };